var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/document-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8305 7.3875V15.0785C17.8305 17.0891 16.1877 18.7319 14.1771 18.7319H7.24628C5.23568 18.7319 3.59287 17.0891 3.59287 15.0785V7.3875C3.59287 5.98988 4.37749 4.77208 5.52991 4.15909C5.9304 3.94659 6.42896 4.23265 6.42896 4.69035C6.42896 5.98988 7.49147 7.0524 8.79101 7.0524H12.6324C13.9319 7.0524 14.9944 5.98988 14.9944 4.69035C14.9944 4.23265 15.4848 3.94659 15.8935 4.15909C17.0459 4.77208 17.8305 5.98988 17.8305 7.3875Z",
    fill: "#31BC0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6324 2.38552H8.79101C7.941 2.38552 7.24628 3.07206 7.24628 3.92207V4.69035C7.24628 5.54036 7.93282 6.22691 8.78283 6.22691H12.6324C13.4824 6.22691 14.169 5.54036 14.169 4.69035V3.92207C14.1771 3.07206 13.4824 2.38552 12.6324 2.38552Z",
    fill: "#31BC0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument2);
export default __webpack_public_path__ + "static/media/document-2.b852a15b70ad44b9fb7bb0da46178b0b.svg";
export { ForwardRef as ReactComponent };